import Nav from "./nav"
import Search from "./search"
import Slider from "./slider"
import Services from "./services"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Slider(jQuery)
    Services(jQuery)
})
